import { z } from "zod";
import { apiRequest } from "../../../../shared/api/client";
import type { RfqInvitation } from "../../domain/rfq-types";

const createdInvitationSchema = z.object({ invitation: z.object({ id: z.string().min(1) }) });
const portalLinkSchema = z.object({ portalUrl: z.string().min(1) });
const invalidResponse = () => Object.assign(new Error("Davet işleminin sunucu yanıtı doğrulanamadı."), { code: "INVALID_API_RESPONSE" });

export async function createRfqInvitation(rfqId: string, supplierId: string) {
  const response = await apiRequest<unknown>(`/api/rfqs/${rfqId}/invitations`, {
    method: "POST", headers: { "Idempotency-Key": crypto.randomUUID() }, body: JSON.stringify({ supplierId }),
  });
  const result = createdInvitationSchema.safeParse(response);
  if (!result.success) throw invalidResponse();
  return result.data.invitation.id;
}

export function runRfqInvitationCommand(rfqId: string, invitationId: string, action: "resend" | "revoke") {
  return apiRequest<unknown>(`/api/rfqs/${rfqId}/invitations/${invitationId}/${action}`, {
    method: "POST", headers: { "Idempotency-Key": crypto.randomUUID() }, body: "{}",
  });
}

export async function readRfqTestPortalLink(invitationId: string) {
  const response = await apiRequest<unknown>(`/api/test/rfq-invitations/${invitationId}/mail-capture`, { cache: "no-store" });
  const result = portalLinkSchema.safeParse(response);
  if (!result.success) throw invalidResponse();
  return result.data.portalUrl;
}

const optionalText = z.string().nullish().transform(value => value ?? undefined);
const invitationListSchema = z.array(z.object({
  id: z.string().min(1), recipient: z.string(), status: z.string().min(1),
  supplierId: optionalText, supplier_id: optionalText, supplierName: optionalText, supplier_name: optionalText,
  contactName: optionalText, queueStatus: optionalText, expiresAt: optionalText, createdAt: optionalText, revokedAt: optionalText,
  attemptCount: z.number().int().nonnegative().nullish().transform(value => value ?? undefined),
}).passthrough());
export async function readRfqInvitations(rfqId: string): Promise<RfqInvitation[]> {
  const result = invitationListSchema.safeParse(await apiRequest<unknown>(`/api/rfqs/${rfqId}/invitations`));
  if (!result.success) throw invalidResponse();
  return result.data;
}
